import { Flex, GridItem, Skeleton } from '@nilohealth/core-ui'
import BignumberSkeleton from '@metrics/big-number/bignumber.skeleton'

import { DashboardCard, DashboardCardContent } from '../dashboard.styles'

import DashboardTitle from '../dashboard-title'

const HomeSkeleton = () => {
  return (
    <>
      <DashboardTitle>
        <Flex direction="column" gap="micro">
          <Skeleton variant="text" css={{ height: 'calc($xxsmall)', width: 'calc($giant + $huge)' }} />

          <Skeleton variant="text" css={{ height: '$xxxsmall', width: '$giant' }} />
        </Flex>
      </DashboardTitle>
      <GridItem column="1 / -1" css={{ width: '100%' }}>
        <Flex direction="column" gap="small" css={{ flex: 1 }}>
          <DashboardCard>
            <Skeleton variant="text" css={{ height: 'calc($xxxsmall + $quarck)', width: 'calc($giant + $huge)' }} />

            <DashboardCardContent>
              {Array.from(Array(8).keys()).map(item => (
                <BignumberSkeleton key={item} />
              ))}
            </DashboardCardContent>
          </DashboardCard>

          <DashboardCard>
            <Skeleton variant="text" css={{ height: 'calc($xxxsmall + $quarck)', width: 'calc($giant + $huge)' }} />

            <DashboardCardContent>
              {Array.from(Array(3).keys()).map(item => (
                <BignumberSkeleton key={item} />
              ))}
            </DashboardCardContent>
          </DashboardCard>
        </Flex>
      </GridItem>
    </>
  )
}

export default HomeSkeleton
